import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { BookedTraining } from "../model/BookedTraining";
import { Student } from "../providers/studentsProvider";
import { DialogCloseButton } from "../misc/DialogCloseButton";
import { DialogProps } from "../misc/DialogProps";
import { serverAPI } from "../api/server.api";
import { useState } from "react";

export function CancelBookedTrainingDialog(
  props: DialogProps & {
    student: Student;
    bookedTraining: BookedTraining;
  },
) {
  const { open, student, bookedTraining, onClose } = props;
  const [cancelReason, setCancelReason] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    setCancelReason("");
    onClose();
  };

  const cancel = async () => {
    setIsLoading(true);
    await runSafely(
      () =>
        serverAPI.cancelBookedTraining({
          studentId: student.id,
          bookedTrainingId: bookedTraining.id,
          cancelReason: cancelReason.trim() || undefined,
        }),
      {
        errorMessage: "Fehler beim Abbrechen der Ausbildung.",
        successMessage: `Die Ausbildung "${bookedTraining.shortLabel}" wurde erfolgreich abgebrochen.`,
        onSuccess: handleClose,
      },
    );
    setIsLoading(false);
  };

  return (
    <Dialog open={open} onClose={isLoading ? undefined : handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Ausbildung abbrechen</DialogTitle>
      <DialogCloseButton onClick={handleClose} disabled={isLoading} />
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          {`Möchtest du die Ausbildung "${bookedTraining.shortLabel}" von ${student.name} wirklich abbrechen?`}
        </DialogContentText>
        <TextField
          label="Grund (optional)"
          value={cancelReason}
          onChange={(e) => setCancelReason(e.target.value)}
          fullWidth
          multiline
          rows={3}
          disabled={isLoading}
        />
      </DialogContent>
      <DialogActions>
        <LoadingButton loading={isLoading} variant="contained" color="error" onClick={cancel}>
          Ausbildung abbrechen
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
